module.exports = __webpack_public_path__ + "img/icon_logo3@2x.167c4606.png";